import { useEffect, useState, useRef } from 'react';
import { show } from 'api/advertising';
import AdSenseBanner from 'ui/design-base/AdSenseBanner';
import type { PositionedBanner } from 'types/misc';
import TennistalkerBanner from './TennistalkerBanner';

const Banner = ({ slot, className }: { slot: string; className?: string }) => {
  const [bannerData, setBannerData] = useState<PositionedBanner>();
  const mounted = useRef(true);
  useEffect(() => {
    show(
      slot,
      (response) => {
        mounted.current && setBannerData(response);
      },
      () => {},
    );
    return () => {
      mounted.current = false;
    };
  }, [slot]);

  if (bannerData) {
    const { image_url, destination } = bannerData;
    const bannerClassName = `flex justify-center ${slot}`;
    return (
      <div className={bannerClassName}>
        {image_url === null || destination === null ? (
          <AdSenseBanner slot={'8655737458'} />
        ) : (
          <TennistalkerBanner imageUrl={image_url} destination={destination} className={className} />
        )}
      </div>
    );
  }
  return null;
};

export default Banner;
